(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const d=document.getElementById('drawer'),
          b=document.getElementById('drawer-backdrop'),
          o=document.getElementById('open-drawer'),
          c=document.getElementById('close-drawer');
    function open(){ d.classList.add('open'); b.classList.add('show'); }
    function close(){ d.classList.remove('open'); b.classList.remove('show'); }
    if(o) o.addEventListener('click', open);
    if(c) c.addEventListener('click', close);
    if(b) b.addEventListener('click', close);
  })();
  
  } catch(e) { console.error(e); }
})();
})();
